angular.module('industry-type', ['core'])
    .constant('IndustryTypeConst', {
        eventUpdate: 'industry-type.updated'
    })
    .factory('IndustryType', function ($resource) {
        return $resource('/crm/api/industry-type/:id', {}, {
            list: {method: 'GET', isArray: false},
            update: {method: 'PUT'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/industry-type/autocomplete'}
        })
    })
    .service('IndustryTypeService', function ($rootScope, modals, IndustryType, IndustryTypeConst) {
        this.edit = entity => {
            return modals.open('app/industry-type/edit-modal.html', 'IndustryTypeDialogController', angular.copy(entity), {size: 'md'}, "$ctrl")
        }
        this.add = () => {
            let entity = {
                active: true,
                id: null
            }
            return this.edit(entity)
        }
        this.remove = item => {
            return modals.confirmDelete(item.name, () => IndustryType.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(IndustryTypeConst.eventUpdate)))
        }
    })
    .controller('IndustryTypeDialogController', function ($timeout, $scope, $rootScope, $uibModalInstance, data, toastr, IndustryType, IndustryTypeConst) {
        this.$onInit = () => {
            this.item = data
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = IndustryType.update(this.item).$promise
            } else {
                promise = IndustryType.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(IndustryTypeConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
    .component('industryTypeList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/industry-type/list.html',
        controller: function ($state, $scope, IndustryTypeService, IndustryTypeConst) {
            this.reset = () => this.filters = {}
            this.IndustryTypeService = IndustryTypeService
            $scope.$on(IndustryTypeConst.eventUpdate, () => $state.reload())
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('industryTypeList', {
            parent: 'app',
            url: '/industry-type?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'industryTypeList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (IndustryType, $stateParams) => IndustryType.list(angular.copy($stateParams)).$promise
            }
        })
    })
